

export const products = [
  // ---------- ELECTRONICS ----------
  {
    id: 1,
    title: "Wireless Headphones",
    price: 2999,
    image: "https://images.pexels.com/photos/3394667/pexels-photo-3394667.jpeg",
    category: "Electronics",
  },
  {
    id: 2,
    title: "Smart Watch",
    price: 4999,
    image: "https://images.pexels.com/photos/267394/pexels-photo-267394.jpeg",
    category: "Electronics",
  },
  {
    id: 3,
    title: "Gaming Keyboard",
    price: 2499,
    image: "https://images.pexels.com/photos/2115257/pexels-photo-2115257.jpeg",
    category: "Electronics",
  },
  {
    id: 4,
    title: "Bluetooth Speaker",
    price: 1899,
image: "https://images.pexels.com/photos/18589085/pexels-photo-18589085.jpeg",
    category: "Electronics",
  },
  {
    id: 5,
    title: "DSLR Camera",
    price: 25999,
image: "https://images.pexels.com/photos/274973/pexels-photo-274973.jpeg",
    category: "Electronics",
  },

  // ---------- FASHION ----------
  {
    id: 6,
    title: "Running Shoes",
    price: 1999,
    image: "https://images.pexels.com/photos/7432/pexels-photo.jpg",
    category: "Fashion",
  },
  {
    id: 7,
    title: "Casual Jacket",
    price: 3499,
    image: "https://images.pexels.com/photos/28919276/pexels-photo-28919276.jpeg",
    category: "Fashion",
  },
  {
    id: 8,
    title: "Men's T-Shirt",
    price: 999,
    image: "https://images.pexels.com/photos/428340/pexels-photo-428340.jpeg",
    category: "Fashion",
  },
  {
    id: 9,
    title: "Women's Handbag",
    price: 2799,
image: "https://images.pexels.com/photos/30748146/pexels-photo-30748146.jpeg",
    category: "Fashion",
  },
  {
    id: 10,
    title: "Sunglasses",
    price: 1499,
    image: "https://images.pexels.com/photos/46710/pexels-photo-46710.jpeg",
    category: "Fashion",
  },

  // ---------- HOME APPLIANCES ----------
  {
    id: 11,
    title: "Electric Kettle",
    price: 1599,
    image: "https://images.pexels.com/photos/4910379/pexels-photo-4910379.jpeg",
    category: "Home",
  },
  {
    id: 12,
    title: "Coffee Maker",
    price: 3299,
    image: "https://images.pexels.com/photos/2748535/pexels-photo-2748535.jpeg",
    category: "Home",
  },
  {
    id: 13,
    title: "Table Lamp",
    price: 1299,
    image: "https://images.pexels.com/photos/1125137/pexels-photo-1125137.jpeg",
    category: "Home",
  },
  {
    id: 14,
    title: "Wall Clock",
    price: 899,
    image: "https://images.pexels.com/photos/21294/pexels-photo.jpg",
    category: "Home",
  },
  {
    id: 15,
    title: "Office Chair",
    price: 6999,
    image: "https://images.pexels.com/photos/1957478/pexels-photo-1957478.jpeg",
    category: "Home",
  },

  // ---------- MOBILES ----------
  {
    id: 16,
    title: "Android Smartphone",
    price: 12999,
    image: "https://images.pexels.com/photos/404280/pexels-photo-404280.jpeg",
    category: "Mobiles",
  },
  {
    id: 17,
    title: "iPhone",
    price: 69999,
    image: "https://images.pexels.com/photos/607812/pexels-photo-607812.jpeg",
    category: "Mobiles",
  },
  {
    id: 18,
    title: "Wireless Earbuds",
    price: 2499,
    image: "https://images.pexels.com/photos/9130508/pexels-photo-9130508.jpeg",
    category: "Mobiles",
  },
  {
    id: 19,
    title: "Power Bank",
    price: 1499,
    image: "https://images.pexels.com/photos/18105/pexels-photo.jpg",
    category: "Mobiles",
  },
  {
    id: 20,
    title: "Charging Cable",
    price: 399,
    image: "https://images.pexels.com/photos/5208772/pexels-photo-5208772.jpeg",
    category: "Mobiles",
  },
];
